import intlTelInput from 'intl-tel-input/intlTelInputWithUtils';
import { ru } from 'intl-tel-input/i18n';
import { closest } from './helpers';

/** @param {HTMLInputElement} $input */
export default function initPhoneInputMask($input) {
	const onPhoneInput = event => {
		if (!event.isTrusted) return;

		if ($input.value.length > 0) {
			$input.intl.setNumber($input.value);
		}

		$inputPrimary.setAttribute('not-empty', '');
	};

	const onPhoneBlur = () => {
		$inputPrimary.setAttribute('not-empty', '');
	};

	$input.intl = intlTelInput($input, {
		i18n: ru,
		onlyCountries: ['ru'],
		autoPlaceholder: 'polite',
		allowDropdown: false,
		showFlags: true,
		separateDialCode: true,
		useFullscreenPopup: false,
		strictMode: true,
		hiddenInput: () => ({ phone: 'tel' }),
	});

	const $inputPrimary = closest($input, 'input-primary');
	$inputPrimary.setAttribute('not-empty', '');
	$input.addEventListener('input', onPhoneInput, false);
	$input.addEventListener('blur', onPhoneBlur, false);
}
